import React from 'react'
import { motion } from "motion/react"
import Work from "./Work.js"
import WorkCardData from "../Data/ProjectCardData.js"
import { variants, useRevealInitial } from "../lib/motion"

const ProjectCard = () => {
  return (
    <section className="mx-auto max-w-5xl px-6 py-16" id="projects">
      <span className="font-mono text-sm uppercase tracking-widest text-signal-400">{"// Projects"}</span>
      <h1 className="mt-3 mb-10 text-3xl font-semibold text-mist-100">Projects</h1>

      <motion.div
        className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3"
        initial={useRevealInitial("hidden")}
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        variants={variants.staggerContainer}
      >
        {WorkCardData.map((val, ind) => (
          <motion.div key={ind} variants={variants.fadeUp}>
            <Work
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              view={val.view}
              source={val.source}
              date={val.date}
              hideBtns={val.hideBtns}
            />
          </motion.div>
        ))}
      </motion.div>
    </section>
  )
}

export default ProjectCard
